import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MODAL_CUSTOM_DATA } from "../../utils/create-modal-injector";
import { ProductIdentifierModalProps } from "./dc-product-identifier-modal-props";

@Component({
  selector: 'app-dc-product-identifier-modal',
  templateUrl: './dc-product-identifier-modal.component.html',
  styleUrls: ['./dc-product-identifier-modal.component.scss'],
})
export class DcProductIdentifierModalComponent {
  private readonly props = inject<ProductIdentifierModalProps>(MODAL_CUSTOM_DATA);
  protected readonly modal = inject<NgbActiveModal>(NgbActiveModal);

  protected title: string;
  protected canReallocate: boolean;
  protected data: {
    typeProdIdentifiers: string;
    codeProdIdentifiers: string;
  }[];

  constructor() {
    this.title = this.props.title || '';
    this.data = this.props.data || [];
    this.canReallocate = this.props.canReallocate;
  }
}
